export default __webpack_public_path__ + "static/media/category-right-arrow.62c017a1.svg";